import { render } from "./SalePrice.vue?vue&type=template&id=5633eab4&scoped=true"
import script from "./SalePrice.vue?vue&type=script&lang=js"
export * from "./SalePrice.vue?vue&type=script&lang=js"

import "./SalePrice.vue?vue&type=style&index=0&id=5633eab4&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5633eab4"]])

export default __exports__